var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('task-detail-template',{attrs:{"task":_vm.task}})}
var staticRenderFns = []

export { render, staticRenderFns }